import React, { useState } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';
import '../styles/EditModal.css';

function AddUserModal({ onClose, onUserAdded, currentUserRole }) {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        password: '',
        role: 'user'  // Default to User
    });
  const [submitting, setSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/users`,
        formData,
        { withCredentials: true }
      );

      if (response.data.success) {
        toast.success(`✅ ${formData.name} added as User!`);
        onUserAdded();
        onClose();
      }
    } catch (err) {
      toast.error(err.response?.data?.error || 'Failed to add user');
      console.error('Error adding user:', err);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="edit-modal-overlay" onClick={onClose}>
      <div className="edit-modal-content" onClick={(e) => e.stopPropagation()}>
        
        <div className="edit-modal-header">
          <h2>👤 Add New User</h2>
          <button onClick={onClose} className="close-button">✕</button>
        </div>

        <form onSubmit={handleSubmit} className="edit-form">
          
          <div className="form-group">
            <label>Full Name *</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              disabled={submitting}
              placeholder="e.g., Sarah Johnson"
            />
          </div>

          <div className="form-group">
            <label>Email *</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              disabled={submitting}
              placeholder="e.g., sarah@scoutsask.ca"
            />
            <span className="field-hint">📧 They'll use this to log in</span>
          </div>

          <div className="form-group">
            <label>Temporary Password *</label>
            <input
              type="text"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
              disabled={submitting}
              placeholder="e.g., Scout2026!"
            />
            <span className="field-hint">🔑 Share this with the new user - they should change it after first login</span>
          </div>

          <div className="form-group">
            <label>Role *</label>
            <select
              name="role"
              value={formData.role}
              onChange={handleChange}
              disabled={submitting}
            >
              <option value="user">👤 User</option>
              <option value="admin">👑 Admin (Full Access)</option>
              {currentUserRole === 'superadmin' && (
                <option value="superadmin">⚡ Super Admin (Debug Access)</option>
              )}
            </select>
            <span className="field-hint">⚠️ Admins have full system access including user management</span>
          </div>

          <div className="edit-form-actions">
            <button 
              type="button" 
              onClick={onClose} 
              className="btn-secondary"
              disabled={submitting}
            >
              Cancel
            </button>
            <button 
              type="submit" 
              className="btn-primary"
              disabled={submitting}
            >
              {submitting ? '⏳ Adding...' : '✅ Add User'}
            </button>
          </div>

        </form>

      </div>
    </div>
  );
}

export default AddUserModal;